<template>
    <div class="clients">
        <div
            v-if="!tokensIsLoading && tokens.length"
        >
            <div class="client-item client-item_header">
                <div class="client-item__row client-item__row_name">{{ $t('clients.authorizedClients.name') }}</div>
                <div class="client-item__row client-item__row_scopes">{{ $t('clients.authorizedClients.privileges') }}</div>
                <div class="client-item__row client-item__row_btns" />
            </div>
            <div
                v-for="token in orderBy(tokens, 'id')"
                :key="token.id"
                class="client-item"
            >
                <div class="client-item__row client-item__row_name" :data-title="$t('clients.authorizedClients.name')">{{ token.name }}</div>
                <div class="client-item__row client-item__row_scopes" :data-title="$t('clients.authorizedClients.privileges')">{{ token.scopes.join(', ') }}</div>
                <div class="client-item__row client-item__row_btns">
                    <div
                        class="client-item__btn"
                        @click="toggleDelPopup(token.id, token.name)"
                    >
                        <svg width="16px" height="20px" viewBox="0 0 16 20">
                            <defs>
                                <linearGradient x1="68.5985166%" y1="13.6777936%" x2="24.1004652%" y2="100%" id="linearGradient">
                                    <stop stop-color="#F59C07" offset="0%" />
                                    <stop stop-color="#F57507" offset="100%" />
                                </linearGradient>
                            </defs>
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g class="color-icon" transform="translate(-1234.000000, -449.000000)" fill-rule="nonzero">
                                    <g transform="translate(30.000000, 220.000000)">
                                        <g transform="translate(20.000000, 229.000000)">
                                            <g transform="translate(1184.000000, 0.000000)">
                                                <path d="M9.08407313,5.55555556 L8.88888889,16.6666667 L10.9159269,16.6666667 L11.1111111,5.55555556 L9.08407313,5.55555556 Z M6.47148243,5.55555556 L4.44444444,5.55555556 L4.63962868,16.6666667 L6.66666667,16.6666667 L6.47148243,5.55555556 Z M12.4117847,17.5255086 L12.4111048,17.5579504 C12.4111048,17.6216249 12.3533061,17.6734109 12.2825878,17.6734109 L3.52235535,17.6734109 C3.45073038,17.6734109 3.39247843,17.6216249 3.39247843,17.5579504 L2.94708898,5.24398293 L0.679569373,5.24398293 L1.12586547,17.5766901 C1.13742519,18.7429816 2.2079465,19.6884274 3.52235535,19.6884274 L12.2825878,19.6884274 C13.5963167,19.6884274 14.6666113,18.7427801 14.6777177,17.5764886 L15.1240138,5.24398293 L12.8564942,5.24398293 L12.4117847,17.5255086 Z M11.3827737,2.18321603 L10.9789431,2.13162821e-14 L4.37631245,2.13162821e-14 L3.97248183,2.18321603 L0,2.18321603 L0,4.44444444 L15.5555556,4.44444444 L15.5555556,2.18321603 L11.3827737,2.18321603 Z" />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>{{ $t('clients.authorizedClients.revoke') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="popup__box"
            v-if="showDelPopup"
        >
            <div class="popup__title">
                <span>
                    {{ $t('clients.authorizedClients.removeConfirmationHeader', {name: token.name}) }}
                </span>
            </div>

            <div class="popup__text">
                <span>
                    {{ $t('clients.authorizedClients.removeConfirmationBody') }}
                </span>
            </div>

            <div>
                <Button
                    type="primary"
                    @click.native="deleteClient(token.id)"
                    class="da-ui--color__btn_fill"
                >
                    <span>{{ $t('clients.yes') }}</span>
                </Button>

                <Button
                    @click.native="toggleDelPopup"
                    style="margin-left: 15px;"
                >
                    <span>{{ $t('clients.cancel') }}</span>
                </Button>
            </div>
        </div>

        <div
            class="cape"
            v-if="globalLoader || showDelPopup"
        />

        <div
            v-if="tokensIsLoading || globalLoader"
        >
            <span>{{ $t('clients.loading') }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { ACTIONS as ACTIONS_CLIENTS } from '../../store/clients'

import Button from '../../components/ui/button'

export default {
    name: 'AuthorizedClients',

    components: {
        Button,
    },

    data: () => {
        return {
            showDelPopup: false,
            token: {
                name: '',
                id: '',
            },
        }
    },

    computed: {
        ...mapGetters([
            'tokensIsLoading',
            'tokens',
            'globalLoader',
        ])
    },

    mounted() {
        this.$store.dispatch(ACTIONS_CLIENTS.FETCH_TOKENS)
    },

    methods: {
        orderBy(arr, key) {
            return [ ...arr ].sort((a, b) => b[key] - a[key])
        },

        deleteClient(id) {
            this.toggleDelPopup()
            this.$store.dispatch(ACTIONS_CLIENTS.DEL_TOKENS, id)
        },

        toggleDelPopup(id, name) {
            if (this.showDelPopup) {
                this.showDelPopup = false
                this.token.id = ''
                this.token.name = ''
            } else {
                this.showDelPopup = true
                this.token.id = id
                this.token.name = name
            }
        },
    },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.clients {
    margin-bottom: 40px;
    margin-top: 20px;
    min-height: 100px;
    color: #838383;

    &__header {
        margin-bottom: 20px;

        &-desc {
            padding-right: 20px;

            h1 {
                font-size: 24px;
                font-weight: 300;
                color: rgba(241, 241, 241, 1);
                margin: 0 0 15px 0;
            }

            p {
                font-size: 14px;
                color: rgba(131, 131, 131, 1);
                line-height: 1.5;
            }
        }

        @include bp('xs') {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}

.popup {
    &__box {
        position: fixed;
        min-width: 280px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #1f1f1f;
        border-radius: 8px;
        // max-width: 600px;
        padding: 30px;
        z-index: 3;
        box-shadow: 0 4px 16px rgba(black, .2);
    }

    &__title {
        font-size: 22px;
        font-weight: 300;
        color: rgba(241, 241, 241, 1);
        line-height: 1;
        margin-bottom: 30px;
    }

    &__text {
        line-height: 1;
        margin-bottom: 30px;
    }

    &__close {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        opacity: .7;

        svg {
            display: block;
        }

        &:hover {
            opacity: 1;
        }
    }
}

.client-item {
    padding: 20px;
    color: rgba(241, 241, 241, 1);
    line-height: 20px;
    cursor: default;
    border-radius: 3px;

    @include bp('xs') {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

    &_header {
        padding: 10px 20px;
        color: rgba(131, 131, 131, 1);
        display: none;

        @include bp('xs') {
            display: flex;
        }
    }

    &:nth-child(2n) {
        background: #262626;
    }

    &__btn {
        display: inline-block;
        line-height: 20px;
        border: 0;
        margin-left: 30px;
        white-space: nowrap;
        cursor: pointer;
        margin-top: 15px;

        @include bp('md') {
            margin-top: 0;
        }

        svg {
            display: inline-block;
            vertical-align: middle;
            line-height: inherit;
            margin-right: 10px;
        }

        span {
            vertical-align: middle;
            line-height: inherit;
        }

        .color-icon {
            fill: #838383;
        }

        &:hover {
            color: rgba(245, 125, 7, 1);

            .color-icon {
                fill: url(#linearGradient);
            }
        }
    }

    &__row {
        &_name,
        &_scopes {
            &:before {
                display: block;
                content: attr(data-title);
                font-size: .8em;
                color: #838383;
            }

            @include bp('xs') {
                &:before {
                    display: none;
                }
            }
        }

        &_scopes {
            margin: 15px 0;
        }

        &_btns {
            text-align: right;
        }

        @include bp('xs') {
            &_name {
                width: 35%;
            }

            &_scopes {
                width: 65%;
                margin: 0;
            }

            &_btns {
                width: 100%;
            }
        }

        @include bp('md') {
            &_name {
                width: 20%;
            }

            &_scopes {
                width: 50%;
            }

            &_btns {
                width: 30%;
            }
        }
    }
}

.btn_add-client {
    svg {
        path {
            fill: #fff;
        }
    }

    &:hover {
        svg {
            path {
                fill: #f57507;
            }
        }
    }
}

.popup__confirm {
    position: fixed;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    border-radius: 8px;
    background-color: #1f1f1f;
    box-shadow: 0 4px 16px rgba(black, .2);
}

.cape {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1c1c1c;
    opacity: .8;
}
</style>
